<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md7 lg8 xs12 sm11>
        <!-- PESTEL -->
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Gestionando el futuro ante los desafíos del país y del mundo.</h4>
              <p
                class="pull"
              >En relación a un análisis de as variables políticas, sociales, económicas, tecnológicas y ambientales; además, de los diversos desafíos globales en materia de educación superior se identifican datos e información clave para la proyección institucional y de las respectivas áreas del conocimiento.</p>
            </v-flex>
          </v-layout>
          <br />
          <v-flex md12 lg12 xs12 sm12>
            <iframe
              class="video"
              src="https://www.youtube.com/embed/jD5uJwz5oIE"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>

            <!-- <v-carousel height="425px" hide-delimiters class="carousel">
              <v-carousel-item v-for="(item,i) in carousel" :key="i" :src="item"></v-carousel-item>
            </v-carousel>-->
          </v-flex>
        </v-flex>
      </v-flex>

      <v-flex md1.5 lg1.5 xs0 sm0 hidden-sm-and-down>
        <v-layout>
          <v-flex md12 lg12 xs12 sm12>
            <v-navigation-drawer floating permanent stateless class="drawner" value="true">
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(4)"
                        target="_blank"
                      >PESTEL</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(5)"
                        target="_blank"
                      >tendencias globales</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(11)"
                        target="_blank"
                      >ODS</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="plantilla = true"
                      >Datos 2030</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="dialog=true"
                      >Semana del futuro</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-flex>
        </v-layout>
        <!-- <v-layout row>
          <v-flex md10 lg10 xs12 sm11>
            <img :src="img3" class="image" @click="dialog = true" />
          </v-flex>
        </v-layout>-->
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-navigation-drawer floating permanent stateless class="drawner" value="true">
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(4)"
                    target="_blank"
                  >PESTEL</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(5)"
                    target="_blank"
                  >tendencias globales</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(11)"
                    target="_blank"
                  >ODS</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn small color="#EB7704" class="button" @click="plantilla = true">Datos 2030</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn small color="#EB7704" class="button" @click="dialog=true">Semana del futuro</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog v-model="dialog" width="700px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Semana del futuro</span>
          </v-card-title>
          <v-flex md12 lg12 xs12 sm12>
            <v-card v-for="(n,index) in filesDge.dge" :key="index">
              <v-layout align-center justify-center v-if="index >= 12">
                <v-flex md8 lg8 xs8 sm8>
                  <h4 class="pull" for="sel1">{{n["nombre_archivo"]}}</h4>
                </v-flex>
                <v-flex md2 lg2 xs2 sm2>
                  <v-btn @click="downloadFile(index)" color="warning" small fab dark>
                    <v-icon>save_alt</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="dialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="plantilla" width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card >
          <v-flex md12 lg12 xs12 sm12>
            <v-carousel height="425px" hide-delimiters class="carousel">
              <v-carousel-item v-for="(item,i) in carousel" :key="i" :src="item"></v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../assets/Captura2.png";
import img2 from "../../assets/entorno.png";
import img3 from "../../assets/nuevaasistencia.png";

import c1 from "../../assets/carrusel/1.png";
import c2 from "../../assets/carrusel/2.png";
import c3 from "../../assets/carrusel/3.png";
import c4 from "../../assets/carrusel/4.png";
import c5 from "../../assets/carrusel/5.png";
import c6 from "../../assets/carrusel/6.png";
import c7 from "../../assets/carrusel/7.png";
import c8 from "../../assets/carrusel/8.png";
import c9 from "../../assets/carrusel/9.png";
import c10 from "../../assets/carrusel/10.png";
import c11 from "../../assets/carrusel/11.png";
import c12 from "../../assets/carrusel/12.png";
import c13 from "../../assets/carrusel/13.png";
import c14 from "../../assets/carrusel/14.png";
import c15 from "../../assets/carrusel/15.png";
import c16 from "../../assets/carrusel/16.png";
import c17 from "../../assets/carrusel/17.png";
import c18 from "../../assets/carrusel/18.png";
import c19 from "../../assets/carrusel/19.png";
import c20 from "../../assets/carrusel/20.png";
import c21 from "../../assets/carrusel/21.png";
import c22 from "../../assets/carrusel/22.png";

export default {
  data() {
    return {
      c1: c1,
      c2: c2,
      c3: c3,
      c4: c4,
      c5: c5,
      c6: c6,
      c7: c7,
      c8: c8,
      c9: c9,
      c10: c10,
      c11: c11,
      c12: c12,
      c13: c13,
      c14: c14,
      c15: c15,
      c16: c16,
      c17: c17,
      c18: c18,
      c19: c19,
      c20: c20,
      c21: c21,
      c22: c22,
      carousel: [
        c1,
        c2,
        c3,
        c4,
        c5,
        c6,
        c7,
        c8,
        c9,
        c10,
        c11,
        c12,
        c13,
        c14,
        c15,
        c16,
        c17,
        c18,
        c19,
        c20,
        c21,
        c22
      ],
      dialog: false,
      plantilla: false,
      img2: img2,
      img3: img3,
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1,
      items: [
        {
          title: "° PESTEL",
          icon: "dashboard",
          path: "1"
        },
        { title: "° Tendencias", icon: "question_answer", path: "2" },
        { title: "° Análisis encuestas", icon: "question_answer", path: "3" },
        {
          title: "° Análisis de entrevistas",
          icon: "question_answer",
          path: "4"
        },
        { title: "° Posicionamiento USACH", icon: "question_answer", path: "5" }
      ],
      right: null
    };
  },
  mounted() {
    axios
      .get(
        process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=0",
        this.auth
      )
      .then(response => {
        this.filesDge = response.data;
        //console.log(this.filesDge);
        //console.log(this.filesDge["dge"][1]);
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },
    algo() {
      alert("algo");
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      if (pathFile != "") {
        axios
          .get(
            process.env.ROOT_API +
              "/uploadFileDcaEtc/downloadFile?dir=" +
              pathFile,
            {
              responseType: "arraybuffer",
              headers: { Authorization: "" + this.$session.get("jwt") }
            }
          )
          .then(response => {
            //console.log("archivo descargado ....");
            //console.log(response);
            this.forceFileDownload(response, nameFile);
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        alert("Contenido no disponible");
      }
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    sendDge() {
      this.dialog = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>


<style scoped>
.carousel {
  height: 425px !important;
  width: 425px !important;
  margin: auto !important;
}
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.dialog_plantilla{
  width: 450px!important;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.image {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/Entorno.vue